<script setup lang="ts">
import { IonModal } from '@ionic/vue';

defineProps({
  modelValue: { type: Boolean, required: true },
});

const emit = defineEmits(['update:modelValue']);

function onDidDismiss() {
  emit('update:modelValue', false);
}
</script>

<template>
  <ion-modal
    class="modal-default"
    :is-open="modelValue"
    @did-dismiss="onDidDismiss"
  >
    <div class="wrapper">
      <slot></slot>
    </div>
  </ion-modal>
</template>

<style scoped>
.modal-default {
  --width: fit-content;
  --min-width: 250px;
  --max-width: 600px;
  --height: auto;
  --max-height: 90vh;
  --border-radius: 15px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

.wrapper {
  background-color: white;
  padding: 15px;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
